import AppBackgroundColor from '@components/app-background-color/AppBackgroundColor';
import { ContentBlock } from '@layouts/ContentBlocks';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { makeSeoData } from 'config/next-seo.config';
import Head from 'next/head';
import { NextSeo } from 'next-seo';
import React from 'react';

import JobCard from '../../../components/cards/JobCard';
import useStyles from '../careers.style';

const title = 'Manager / Director, Software Engineering (Remote) - Careers at Guest House';
const description = 'We’re building an engineering team to support our rapidly expanding user base. We’re in search of talented developers and engineers–at various levels of experience–to join our team and help shape the future of our products. We pride ourselves on writing clean, scalable code that results in amazing experiences for our end-users.';
const jobTitle = 'Manager / Director, Software Engineering (Remote)';
const location = 'Remote - Full Time';
const applyLink = 'https://www.linkedin.com/jobs/view/2927560117/?refId=oh8nS9KjKPBPNRUCREmEXQ%3D%3D&trackingId=l5qk2BQDEf4pb6hS56Jemw%3D%3D';

const responsibilites = [
  'Directly manage and mentor early career and mid-level engineers',
  'Lead sprint ceremonies such as planning, standup, and retrospective',
  'Monitor the health of our cloud services and user facing applications',
  'Take a leading role working with stakeholders across organization to prioritize features against OKRs and business needs',
  'Contribute performant, stable, organized code to our codebase setting a solid foundation for scale and change',
  'Work with your peers to promote best practices and ensure a high quality bar is maintained',
  'Iterate on internal tooling and develop strategies for continuous improvement and testing',
  'Report directly into the COO',

];

const experience = [
  '5+ years of professional web development experience',
  '2+ years of management experience, preferably in technology teams',
  'Experience developing, testing, and shipping code for user facing products',
  'Experience with continuous integration and automation',
  'Experience with unit, functional, and integration testing',
  'Experience working in a team environment and collaborating with cross-functional groups',
];

const preferredSkills = [
  'TypeScript / NodeJS',
  'React.JS / Webpack',
  'Next.JS',
  'GitHub',
  'Google Cloud / Firebase',
  'Serverless Architecture',
  'NoSQL / MySQL / GraphQL',
  'CSS / Sass / JSS',
  'Continuous Integration, Improvement, Delivery',
  'Test Driven Development',
];

function CareersSoftwareEngineer() {
  const { classes, theme } = useStyles();


  return (
    <>
      <AppBackgroundColor backgroundColor="#f6f1f0" />

      <Head>
        <title>
          {title}
        </title>
      </Head>

      <NextSeo {...makeSeoData({ pageTitle: title, metaTitle: title, metaDescription: description })} />

      <ContentBlock
        maxWidth={1365}
        margin={[8, 0]}
      >
        <Grid
          item
          md={8}
          style={{ margin: 'auto' }}
        >
          <JobCard
            jobTitle={jobTitle}
            location={location}
            applyLink={applyLink}
            preferredSkills={preferredSkills}
            style={{ textAlign: 'left' }}
          >
            <Typography
              component="h2"
              variant="h4Alt"
              className={classes.jobDescriptionHeader}
            >
              The Role
            </Typography>

            <Typography className={classes.jobDescriptionText}>
              We&apos;re building an engineering team to support our rapidly growing company and feature set. We&apos;re in search of an engineering manager or director to help shape the future of our products and technology. From ideating on the best tools to enable our teams to operate faster and more efficiently to creating the best consumer facing product showcasing our exceptional design, this role will have limitless opportunity to build new features and grow our engineering team to scale the company.
            </Typography>

            <Typography
              style={{ marginTop: '16px' }}
              className={classes.jobDescriptionText}
            >
              The right person for this role will embrace a player-coach mentality, contributing as much if not more to our code base and feature development along with managing, mentoring and growing our engineering team.
            </Typography>

            <Typography
              component="h3"
              variant="h5Alt"
              className={classes.jobDescriptionHeader}
            >
              In this role, you will:
            </Typography>

            {responsibilites.map((responsibility, i) => (
              <Typography
                key={i}
                component="ul"
              >
                <Typography
                  component="li"
                  className={classes.jobDescriptionText}
                >
                  {responsibility}
                </Typography>
              </Typography>
            ))
            }

            <Typography
              className={classes.jobDescriptionText}
              style={{ margin: theme.spacing(2, 0), fontWeight: 'bold', }}
            >
              We&apos;re prioritizing the following experience and capabilities, and are open to conversations with engineers at different levels. If you&apos;re interested in contributing at an early stage startup and making a difference, let us know!
            </Typography>

            {experience.map((experience, i) => (
              <Typography
                key={i}
                component="ul"
              >
                <Typography
                  component="li"
                  className={classes.jobDescriptionText}
                >
                  {experience}
                </Typography>
              </Typography>
            ))}
          </JobCard>
        </Grid>
      </ContentBlock>
    </>
  );
}

export default CareersSoftwareEngineer;
